import { IControlledMutator, IOptions } from "sonobello.utilities.react";

import { Customer, ImprovementAreas } from "../../../../Models/Customer";
import SessionContextValueProvider from "../../../Providers/Value/SessionContextValueProvider";
import UserContextValueProvider from "../../../Providers/Value/UserContextValueProvider";
import AreasOfInterestPicker, { IAreasOfInterestPickerProps } from "../Components/AreasOfInterestPicker";
import { AreaOfInterest } from "../Types/AreaOfInterest";

type IImprovementAreasToAreasOfInterestPickerProps = IControlledMutator<Customer["improvementAreas"]> &
  IAreasOfInterestPickerProps;

/** A temporary composition component which translates between the new {@link AreaOfInterest} model and the old
 * {@link ImprovementAreas} model.
 */
const ImprovementAreasToAreasOfInterestPicker: React.FC<IImprovementAreasToAreasOfInterestPickerProps> = ({
  value,
  onChange,
  options,
  ...rest
}) => {
  return AreasOfInterestPicker({
    value: ImprovementAreas.toAreasOfInterest(value, options),
    onChange: a => onChange(ImprovementAreas.fromAreasOfInterest(a, options)),
    options,
    ...rest
  });
};

/** A provisioned {@link AreasOfInterestPicker} which is controlled by the session context. */
const SessionContextAreasOfInterestPicker = SessionContextValueProvider<
  IControlledMutator<Customer["improvementAreas"]>,
  IImprovementAreasToAreasOfInterestPickerProps
>({
  Component: ImprovementAreasToAreasOfInterestPicker,
  map: ({ customer: { improvementAreas }, setCustomer }) => ({
    value: improvementAreas,
    onChange: improvementAreas => setCustomer(c => ({ ...c, improvementAreas }))
  })
});

/** A provisioned {@link SessionContextAreasOfInterestPicker} which is provided options by the user context. */
const UserSessionContextAreasOfInterestPicker: React.FC<Pick<IAreasOfInterestPickerProps, "filter" | "label">> =
  UserContextValueProvider<IOptions<AreaOfInterest>, Omit<IAreasOfInterestPickerProps, "onChange" | "value">>({
    Component: SessionContextAreasOfInterestPicker,
    map: ({ areasOfInterest }) => ({ options: areasOfInterest })
  });

export default UserSessionContextAreasOfInterestPicker;
